import { jwtDecode } from 'jwt-decode';

export const isTokenInvalid = (token: string): boolean => {
  try {
    const { exp } = jwtDecode(token) as {
      exp: number;
    };

    const expirationDatetimeInMilliSeconds = exp * 1000;

    return Date.now() >= expirationDatetimeInMilliSeconds;
  } catch {
    return true;
  }
};

export function parseJwt<T>(token: string): T | null {
  try {
    return JSON.parse(atob(token.split('.')[1]).toString());
  } catch (error) {
    console.error('Invalid token', error);
    return null;
  }
}
